import React from 'react';
import Styles from './UploadTerms.module.css';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import Panel from 'Common/Layout/Panel';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import ActionButton from 'Common/Buttons/ActionButton';
import Typography from '@material-ui/core/Typography';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

const UploadTermsView = ({
	grouping,
	year,
	yearUpdated,
	handleSelectClick,
	handleFileSelect,
	filename,
	handleUploadClick,
	uploadResult,
	onClose,
	title,
	inputRef,
	yearSelectorHide,
	typeSelectorHide,
	handleTypeChange,
	type,
	types,
	isUploadDisabled
}) => {
	return (
		<>
			<Page title={title} fitScreen>
				<Section className={yearSelectorHide ? Styles.hide : ''}>
					<Panel title="Select Year">
						<YearSelector grouping={grouping} updateYear={yearUpdated} year={year} numberOfPreviousYears={1} numberOfFutureYears={1} addLoopCheck={true}  />
					</Panel>
				</Section>
				<Section className={typeSelectorHide ? Styles.hide : ''}>
					<Panel title="Select Type">
						<div className={Styles.container}>
							<Typography variant="subtitle1">Type: </Typography>
							<div className={Styles.content}>
								<Select value={type} onChange={handleTypeChange}>
									{types.map(typeItem => (
										<MenuItem key={typeItem} value={typeItem}>
											{typeItem}
										</MenuItem>
									))}
								</Select>
							</div>
						</div>
					</Panel>
				</Section>
				<Section className={isUploadDisabled() ? Styles.hide : ''}>
					<Panel title="Select File">
						<input ref={inputRef} type="file" className={Styles.input} onChange={handleFileSelect} accept=".pdf" />
						<div className={Styles.container}>
							<ActionButton text="Select Template" onClick={handleSelectClick} containerClass={Styles['action-button']} />
							<Typography className={Styles['filename']} variant="subtitle1">
								{filename}
							</Typography>
							{filename && <CloudUploadIcon style={{ fontSize: 42 }} onClick={handleUploadClick} className={Styles.upload} />}
						</div>
					</Panel>
					<ActionButton text="Main Menu" containerClass={Styles.close} onClick={onClose} />
				</Section>
				<div className={Styles.result}>
					<SuccessFailure {...uploadResult} successMessage="Uploaded Successfully" failMessage="Failed to Upload" />
				</div>
			</Page>
		</>
	);
};

export default UploadTermsView;

UploadTermsView.propTypes = {
	grouping: PropTypes.string.isRequired,
	year: PropTypes.string.isRequired,
	yearUpdated: PropTypes.func.isRequired,
	handleSelectClick: PropTypes.func.isRequired,
	handleFileSelect: PropTypes.func.isRequired,
	filename: PropTypes.string,
	handleUploadClick: PropTypes.func.isRequired,
	uploadResult: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string,
	yearSelectorHide: PropTypes.bool.isRequired,
	typeSelectorHide: PropTypes.bool.isRequired,
	handleTypeChange: PropTypes.func.isRequired,
	type: PropTypes.string.isRequired,
	types: PropTypes.array.isRequired,
	isUploadDisabled: PropTypes.func.isRequired
};
